import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { IonApp } from "@ionic/react";
import { CCToastProvider } from "@pymblecitizencoders/cc-ui";
import { PageLayout } from "./pages/layout";
import { EventList } from "./pages/EventList";
import { Event } from "./pages/Event";
import { EventApprovals } from "./pages/EventApprovals";
import { PublishAdmin } from "./pages/PublishAdmin";
import { NoMatch } from "./pages/NoMatch";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 60, // 1 hour
			refetchOnWindowFocus: false,
		},
	},
});

const App: React.FC<{ msalInstance: IPublicClientApplication }> = ({
	msalInstance,
}) => {
	return (
		<React.StrictMode>
			<QueryClientProvider client={queryClient}>
				<MsalProvider instance={msalInstance}>
					<IonApp>
						<CCToastProvider>
							<BrowserRouter>
								<Routes>
									<Route path="/" element={<PageLayout />}>
										<Route
											index
											element={<Navigate to="/home" replace={true} />}
										/>
										<Route path="home" element={<EventList />} />
										<Route path="event/:id" element={<Event />} />
										<Route path="admin" element={<EventApprovals />} />
										{/* The queue moved here. Redirected rather than dropped:
										    it was linked from the calendar and is bookmarked. */}
										<Route
											path="approvals"
											element={<Navigate to="/admin" replace />}
										/>
										<Route path="approvals/admin" element={<PublishAdmin />} />
										{/* The two screens this replaced. Redirected rather than
										    dropped: both were linked from the calendar and the
										    sign-off screen, and somebody has them bookmarked. */}
										<Route
											path="approvals/roles"
											element={<Navigate to="/approvals/admin" replace />}
										/>
										<Route
											path="approvals/chains"
											element={<Navigate to="/approvals/admin" replace />}
										/>
										<Route path="*" element={<NoMatch />} />
									</Route>
								</Routes>
							</BrowserRouter>
						</CCToastProvider>
					</IonApp>
				</MsalProvider>
			</QueryClientProvider>
		</React.StrictMode>
	);
};

export default App;
